var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auto-warpper"},[_c('div',{staticClass:"auto-title"},[_vm._v(" 自动播放 ")]),_c('sp-switch',{staticClass:"auto-btn",model:{value:(_vm.curAutoPlay),callback:function ($$v) {_vm.curAutoPlay=$$v},expression:"curAutoPlay"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }